export default "__VITE_ASSET__179b5983__"